import type { FaireProductEntity } from "../../entity_types/product";

export const p_93kbyhfmr9: FaireProductEntity = {
  token: "p_93kbyhfmr9",
  type: "product",
  name: "Skin Trip Coconut Lotion | Light All-Purpose Moisturizer",
  brandToken: "b_8kx2icdnmx",
  brandName: "Skin Trip",
  imageUrl: "https://cdn.faire.com/fastly/1667e5e93366ab4137159c713b3be2e6384101a00fb07204f904210a275bc93e.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/89f796ea54b0211d22fddee09081bf302d132a5212a5f3647fc7fceb9679437b.jpeg",
    "https://cdn.faire.com/fastly/9fe6a5829b93d70c108657b5e3d7f28ec886e2e5b37ed04575134f21ab0729e5.jpeg",
    "https://cdn.faire.com/fastly/a7f1288f564855602f0c39495df71940c350c38e8bd9d8069a823755627bec12.jpeg",
    "https://cdn.faire.com/fastly/a03892dc69cdc2e7610d0a329a57dc85339e143610e1663909d3c9cc08e647e8.jpeg",
    "https://cdn.faire.com/fastly/c97227e23ff11e2d41f67c01db3900fb2664e043ab3bdd3ef80022e1de27afd3.jpeg"
  ],
  priceDollars: 8,
  description: "Experience the magic of Skin Trip, the iconic coconut moisturizer from Mountain Ocean. Imagine coconut in a bottle—vacation in a jar.\n\nPerfect for after the sun, a shower, or shaving—Skin Trip is your go-to for anytime, anywhere hydration.\n\nThis ultimate lightweight lotion delivers instant, deep hydration like no other. Skin Trip’s luxurious formula blends nourishing coconut oil and soothing aloe vera; moisture that absorbs quickly and leaves your skin feeling velvety smooth without a trace of greasiness.\n\nLovingly crafted in small batches to ensure the highest quality and freshness, this pH-balanced blend is designed to be as gentle as it is effective.\n\n• Free of harsh chemicals.\n• Great for sensitive skin, dry skin, oily skin.\n• Non-greasy formula with calming botanicals.\n• Light tropical scent.\n• Elevate your daily routine, post-beach sun care, or travel kit.\n• This all-purpose cream even smooths hair!\n• The perfect natural skincare gift for the holidays.\n• Woman-owned, US-made, cruelty-free.",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-14T17:06:54.836Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
